import React, { useState } from "react";
import AboutSection from "./content/sections/AboutSection";
import ContactSection from "./content/sections/ContactSection";
import HeroSection from "./content/sections/HeroSection";
import ProjectsSection from "./content/sections/ProjectsSection";
import SkillsSection from "./content/sections/SkillsSection";
import ProjectDialogs from "./content/dialogs/ProjectDialogs";

export default function Content({ booted }) {
  const [openDialog, setOpenDialog] = useState(null);

  return (
    <div className=" max-w-screen overflow-y-hidden overflow-x-hidden">
      <div className="absolute max-w-screen z-30 w-full h-full overflow-y-scroll overflow-x-hidden ">
        <HeroSection booted={booted} />
        <AboutSection />
        <SkillsSection />
        <ProjectsSection onOpenDialog={setOpenDialog} />
        <ContactSection />
      </div>
      <ProjectDialogs openDialog={openDialog} onCloseDialog={() => setOpenDialog(null)} />
    </div>
  );
}
